import type { PartDefinition } from "@rogue/rackbuilder"
import { RackOptions } from "../../../RackTypes"
import { IndyBuilder } from "./FM/indy/indyBuilder"
import { RhinoBuilder } from "./FM/rhino/rhinoBuilder"
import { LatAndLowRowBuilder } from "./FM/lrlp/lowRowBuilder"
import { StandardFMBuilder } from "./FM/standard/standardFMBuilder"
import { SlingerXBuilder } from "./FM/slinger-x/slingerXBuilder"
import { TwinFMBuilder } from "./FM/twin/twinFMBuilder"
import { StandardFMLBuilder } from "./FML/standard/standardFMLBuilder"
import { TwinFMLBuilder } from "./FML/twin/twinFMLBuilder"

export class FunctionalTrainerFactory {
  static build(config: RackOptions): PartDefinition {

    // LRLP — must come before line checks. FML LRLP has line === 'RML' AND
    // latAndLowRowOptions set; checking here first prevents fallthrough to StandardFMLBuilder.
    if (config.latAndLowRowOptions) {
      return new LatAndLowRowBuilder(config).build()
    }

    // Slinger X — standalone rack
    // Checked early so it never falls through to a line/edition builder.
    if (config.slingerX) {
      return new SlingerXBuilder(config).build()
    }

    if (config.line === 'RML') {
      // FML-Twin / Twin-HR
      if (config.edition === 'twin') {
        return new TwinFMLBuilder(config).build()
      }

      // FML-6, FML-HR
      return new StandardFMLBuilder(config).build()
    }

    // Rhino Rack Trainer, Rhino Fxt, Rhino + Indy
    if (config.rhinoRackTrainer || config.edition === 'rhino trainer') {
      return new RhinoBuilder(config).build()
    }

    // Indy
    if (config.leftSide || config.rightSide) {
      return new IndyBuilder(config).build()
    }

    // FM-6-Twin, FM-HR-Twin
    if (config.edition === 'twin') {
      return new TwinFMBuilder(config).build()
    }

    // FM-6, FM-HR
    return new StandardFMBuilder(config).build()
  }
}
